import React from 'react';
import { GroupBenchmarkStatus } from '../../../../services/gamification/gamification.service';
import { groupUsersIcon } from '../../../../assets/images/index';
import './level-status.scss';

interface ClassStatusCardProps {
  groupStatus: GroupBenchmarkStatus;
  t: (key: string) => string;
}

export const ClassStatusCard: React.FC<ClassStatusCardProps> = ({ groupStatus, t }) => {
  const title = t('classStatusTitle').replace('{{level}}', groupStatus.title_level_label);
  const subtitle = t('classStatusSubtitle')
    .replace('{{avg}}', groupStatus.avg_points.toLocaleString())
    .replace('{{needed}}', groupStatus.points_needed_to_next.toLocaleString())
    .replace('{{target}}', groupStatus.target_level_label);

  return (
    <div className="v2-class-status-card">
      <div className="v2-class-status-card__icon-wrapper">
        <img src={groupUsersIcon} alt="" className="v2-class-status-card__icon" />
      </div>
      <div className="v2-class-status-card__content">
        <div className="v2-class-status-card__title">{title}</div>
        <div className="v2-class-status-card__subtitle">{subtitle}</div>
      </div>
    </div>
  );
};
